// Handle video feature teleportation
function handleVideoFeatureTeleport() {
    const videoFeature = $('.product-video-container ');
    const videoFeatureContainer = $('.product-video');
    const mobileContainer = $('.mobile-video-feature');
    const viewportWidth = window.innerWidth;

    // If video feature doesn't exist, exit early
    if (!videoFeature.length) {
        return;
    }

    // Ensure there's only one video feature
    if (videoFeature.length > 1) {
        // Keep only the first one and remove others
        videoFeature.slice(1).remove();
    }

    if (viewportWidth <= 768) {
        // If mobile container exists and video feature is not already in it
        if (mobileContainer.length && !videoFeature.parent().hasClass('mobile-video-feature')) {
            mobileContainer.append(videoFeature);
        }
    } else {
        // If video feature container exists and video feature is in mobile container
        if (videoFeatureContainer.length && videoFeature.parent().hasClass('mobile-video-feature')) {
            videoFeatureContainer.append(videoFeature);
        }
    }
}

// Run on page load and resize
$(document).ready(function() {
    handleVideoFeatureTeleport();
    $(window).on('resize', handleVideoFeatureTeleport);
});
